import styled, { createGlobalStyle } from 'styled-components';

import { ReactComponent as SMS } from '../../../../assets/icons/chat-bubble-line.svg';

interface SelectedProps {
  selected?: boolean;
}

export const GlobalStyle = createGlobalStyle`
  .selected {
    border-color: ${(props) => props.theme.colors.primary};
    border-style: solid;
    border-width: 1px;
  }
`;

export const Wrapper = styled.div`
  display: flex;
  justify-content: flex-start;
  font-size: 15px;
  height: 76px;
  box-shadow: -4px -4px 8px rgba(36, 36, 36, 0.1),
    4px 4px 6px rgba(36, 36, 36, 0.1);
  border-radius: ${(props) =>
    Number(props.theme.radiusCards) ? `${props.theme.radiusCards}px` : '60px'};

  margin: 12px 0;
  background: #fff;
  padding: 15px 0 15px 30px;

  div {
    display: flex;
    flex-direction: column;
  }

  &:hover {
    cursor: pointer;
  }

  @media screen and (max-width: 960px) {
    border-radius: ${(props) =>
      Number(props.theme.radiusCards)
        ? `${props.theme.radiusCards}px`
        : '10px'};
    width: 100%;
    padding: 20px 17px;
    font-size: 14px;
    height: 90px;
  }
`;
export const IconContainer = styled.div`
  font-size: 40px;
  align-items: center;
  justify-content: center;
  width: 5%;
`;
export const MainContainer = styled.div`
  width: 80%;
  margin: 0 20px;
  word-break: break-word;
  span {
    margin: 4px 0;
    color: ${(props) => props.theme.colors.black};
    font-weight: 400;
    font-size: 14px;
  }

  .info {
    font-weight: 700;
  }
  small {
    margin-top: 3px;
    font-size: 11px;
  }

  @media screen and (max-width: 960px) {
    width: 80%;
  }
`;
export const SelectContainer = styled.div<SelectedProps>`
  display: flex;
  align-items: center;
  justify-content: center;
  border: ${(props) =>
    `2px solid ${props.selected ? props.theme.colors.primary : '#7B86A3'}`};
  min-height: 24px;
  min-width: 24px;
  border-radius: 50%;
  align-self: center;
  cursor: pointer;
  span {
    background: ${(props) =>
      props.selected ? props.theme.colors.primary : 'none'};
    align-self: center;
    justify-self: center;
    height: 14px;
    width: 14px;
    border-radius: 50%;
  }
`;

export const IconSMS = styled(SMS)`
  width: 28px;
  height: 28px;
`;
